<template>
  <el-form style="width:500px;margin-left:100px;margin-top:100px;" class="input">
      <el-form-item label="您的建议">
          <el-input type="textarea" v-model="feedback"></el-input>
      </el-form-item>
            <el-form-item label="联系方式">
          <el-input  v-model="feedback2"></el-input>
      </el-form-item>
        <el-form-item>
    <el-button class="button_2" @click="onSubmit">提交</el-button>
  </el-form-item>
  </el-form>
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      feedback: '',
      feedback2: ''
    }
  },
  mounted () {
    document.title = '美钥二维码 - 用户反馈'
  },
  methods: {
    onSubmit () {
      const vm = this
      if (vm.feedback !== '') {
        $.ajax({
          type: 'POST',
          url: '/v1/feedback',
          data: {feedback: vm.feedback + vm.feedback2},
          dataType: 'json',
          success: function () {
            vm.$message.info('提交成功，感谢您的建议')
            vm.$router.push('/')
          }
        })
      } else {
        vm.$message.warning('不能为空！')
      }
    }
  }
}
</script>

<style>
.el-textarea__inner {
  min-height: 100px!important;
}
.button_2 {
    background:#38dba4;width:200px;height:60px;color:white;margin-top:50px;
  border: 1px solid #38dba4;
      width:300px;
  height: 50px;
  color: white;
  font-size: 20px;
  border-radius: 30px;
  padding-left: 20px;
  letter-spacing: 8px;
  font-weight: 100;
}

</style>

